import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { Box, Checkbox, Typography, Container, Paper, Stack, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import RegisterSubmitButton from '../common_modules/components/RegisterSubmitButton';
import RegisterHeaderProgress from '../common_modules/components/RegisterHeaderProgress';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import RegisterLayout from '../common_modules/components/RegisterLayout';
import WrappedCheckBoxFormControlLabel from '../common_modules/components/WrappedCheckBoxFormControlLabel';
import LinkButton from '../common_modules/components/LinkButton';

const Terms: React.FC = () => {
  const [isAgreed, setIsAgreed] = React.useState(false);
  const navigate = useNavigate();
  const translate = useTranslate();
  const isSmallScreen = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  const [termsText, setTermsText] = useState<string>('');

  useEffect(() => {
    const registerToken = sessionStorage.getItem('register_token'); // セッションストレージからトークンを取得
    if (!registerToken) {
      // トークンが存在しない場合は token-error ページにリダイレクト
      navigate('/register/client/token-error', { replace: true });
    }

    const terms = sessionStorage.getItem('inviteTerms');
    setTermsText(terms ?? '');
  }, [navigate]);

  const handleAgreeChange = () => {
    setIsAgreed(!isAgreed);
  };

  const handleNext = () => {
    navigate('/register/client/form');
  };

  const gap = isSmallScreen ? 3 : 5;
  return (
    <RegisterLayout>
      <Container
        sx={{
          maxWidth: { sm: '552px', md: '772px' },
          marginTop: { xs: '20px', sm: '40px' },
          // marginBottom: { xs: '20px', sm: '40px'},
          marginBottom: '40px',
          borderRadius: { sm: '24px', md: '24px' },
          border: { sm: '1px solid #EEEEEE', md: '1px solid #EEEEEE' },
          backgroundColor: '#FFFFFF'
        }}
      >
        <Stack
          direction={'column'}
          spacing={gap}
          gap={4}
          sx={{
            paddingLeft: { xs: '16px', sm: '40px', md: '64px' },
            paddingRight: { xs: '16px', sm: '40px', md: '64px' },
            paddingTop: { sm: '40px', md: '64px' },
            paddingBottom: { sm: '40px', md: '64px' }
          }}
        >
          <Helmet>
            <title>{translate('resources.registers.name.Terms')}</title>
          </Helmet>

          <RegisterHeaderProgress
            title={translate('resources.registers.name.Terms')}
            icon={<DescriptionOutlinedIcon />}
            step={1}
            totalSteps={6}
          />

          <Box display="flex" justifyContent="center">
            <Box
              sx={{
                width: { xs: '288px', sm: '400px' },
                height: '20px',
              }}
              component="img"
              src={`/images/stepper/img_stepper_1.svg`}
              alt="stepper_1"
            />
          </Box>

          <Paper elevation={0} style={{ backgroundColor: '#F5F5F5', padding: 24, height: 540, overflow: 'auto' }}>
            <Typography
              sx={{
                fontSize: '14px',
                lineHeight: '28px',
                letterSpacing: '0.4px',
                fontWeight: 300,
                whiteSpace: 'pre-wrap'
              }}
              paragraph
            >
              {termsText}
            </Typography>
          </Paper>

          <WrappedCheckBoxFormControlLabel
            control={<Checkbox checked={isAgreed} onChange={handleAgreeChange} />}
            label="利用規約に同意する"
          />

          <Stack alignItems="center" spacing={3}>
            <RegisterSubmitButton onClick={handleNext} disabled={!isAgreed}>
              {/* 次へ */}
              基本情報入力へ
            </RegisterSubmitButton>
            {/* <LinkButton href="/register/client/start-register">{'< 戻る'}</LinkButton> */}
            <LinkButton href="/register/client/start-register">{'< 登録開始に戻る'}</LinkButton>
          </Stack>
        </Stack>
      </Container>
    </RegisterLayout>
  );
};

export default Terms;
